var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamatoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 103,
    viewBox: "0 0 31 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.97461 72.3896L11.6221 66.7959L28.7102 76.6393L19.0627 82.233L1.97461 72.3896Z",
    fill: "url(#paint0_linear_1771_58808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.064 82.2323L28.7115 76.6387L28.6553 96.2285L19.0078 101.822L19.064 82.2323Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.92188 91.9795L1.97718 72.3896L19.0653 82.2331L19.0091 101.823L1.92188 91.9795Z",
    fill: "url(#paint1_radial_1771_58808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.0921 82.5195C19.0422 82.5195 18.9931 82.507 18.9485 82.4812L1.86042 72.6387C1.77121 72.5871 1.7168 72.4927 1.7168 72.3904C1.7168 72.288 1.77121 72.1928 1.86042 72.1412L11.5079 66.5475C11.5971 66.4959 11.7069 66.4959 11.797 66.5475L28.8842 76.39C28.9734 76.4416 29.0278 76.536 29.0278 76.6383C29.0278 76.7407 28.9734 76.8359 28.8842 76.8875L19.2366 82.4812C19.192 82.507 19.1421 82.5203 19.0921 82.5203V82.5195ZM2.57851 72.3886L19.0912 81.9L28.1652 76.6392L11.6524 67.1278L2.57851 72.3886Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.0373 102.11C18.9873 102.11 18.9382 102.097 18.8936 102.071C18.8044 102.02 18.7491 101.924 18.75 101.822L18.8053 82.2323C18.8053 82.13 18.8597 82.0365 18.9489 81.9849L28.5964 76.3913C28.6857 76.3396 28.7954 76.3396 28.8855 76.3913C28.9747 76.4429 29.03 76.5381 29.0291 76.6405L28.9738 96.2303C28.9738 96.3326 28.9194 96.4261 28.8302 96.4777L19.1827 102.071C19.1381 102.097 19.0881 102.111 19.0382 102.111L19.0373 102.11ZM19.3807 82.3979L19.3272 101.322L28.3975 96.0629L28.451 77.1389L19.3807 82.3979Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.0366 102.111C18.9866 102.111 18.9375 102.098 18.8929 102.072L1.80574 92.2299C1.71653 92.1783 1.66123 92.083 1.66212 91.9807L1.71743 72.3909C1.71743 72.2885 1.77273 72.1942 1.86194 72.1425C1.95114 72.0918 2.06086 72.0918 2.14918 72.1425L19.2373 81.9851C19.3265 82.0367 19.3818 82.1319 19.3809 82.2343L19.3256 101.824C19.3256 101.926 19.2703 102.021 19.1811 102.072C19.1365 102.098 19.0874 102.111 19.0375 102.111H19.0366ZM2.23749 91.8151L18.7502 101.327L18.8037 82.3989L2.29101 72.8875L2.23749 91.8151Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0.261719 5.99795L9.90923 0.404297L30.6851 12.3713L21.0375 17.9649L0.261719 5.99795Z",
    fill: "url(#paint2_linear_1771_58808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M21.0396 17.9657L30.6871 12.3721L25.1475 68.7937L15.5 74.3873L21.0396 17.9657Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.4979 74.3876L5.51768 68.6382L0.261719 5.99902L21.0375 17.966L15.4979 74.3876Z",
    fill: "url(#paint3_radial_1771_58808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M21.0631 18.2523C21.0131 18.2523 20.964 18.2398 20.9194 18.214L0.143619 6.24707C0.0544137 6.19545 0 6.10111 0 5.99876C0 5.89641 0.0544137 5.80118 0.143619 5.74956L9.79113 0.155903C9.88034 0.104282 9.99006 0.104282 10.0802 0.155903L30.856 12.1229C30.9452 12.1745 30.9996 12.2688 30.9996 12.3712C30.9996 12.4735 30.9452 12.5687 30.856 12.6195L21.2085 18.2131C21.1639 18.2389 21.1139 18.2523 21.064 18.2523H21.0631ZM0.861717 5.99698L21.0622 17.6329L30.1361 12.3721L9.93564 0.73618L0.861717 5.99698Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15.5241 74.674C15.4697 74.674 15.4162 74.6589 15.3689 74.6286C15.2779 74.5708 15.227 74.4667 15.2377 74.359L20.7774 17.9374C20.7863 17.8457 20.8389 17.7638 20.9192 17.7166L30.5667 12.123C30.6604 12.0687 30.7763 12.0714 30.8673 12.1292C30.9583 12.1871 31.0092 12.2921 30.9985 12.3989L25.4588 68.8205C25.4499 68.9122 25.3973 68.994 25.317 69.0412L15.6695 74.6349C15.6249 74.6607 15.5749 74.674 15.525 74.674H15.5241ZM21.3358 18.1394L15.8649 73.8561L24.8986 68.6185L30.3696 12.9017L21.3358 18.1394Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M15.5246 74.6745C15.4747 74.6745 15.4247 74.6621 15.381 74.6362L5.40076 68.8868C5.31869 68.8397 5.26605 68.756 5.25802 68.6617L0.00295992 6.02161C-0.00596057 5.91481 0.0448908 5.81247 0.13588 5.75551C0.226869 5.69855 0.341048 5.69587 0.433821 5.74927L21.2096 17.7162C21.3078 17.7723 21.3631 17.8809 21.3524 17.993L15.8127 74.4146C15.8029 74.5116 15.745 74.5971 15.6575 74.6425C15.6165 74.6638 15.571 74.6745 15.5255 74.6745H15.5246ZM5.81823 68.465L15.282 73.9162L20.76 18.123L0.622042 6.52269L5.81912 68.465H5.81823Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1771_58808",
    x1: 3.74239,
    y1: 83.8926,
    x2: 27.6181,
    y2: 68.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1771_58808",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4461 79.2974) rotate(-47.1612) scale(45.8739 27.09)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1771_58808",
    x1: 2.27334,
    y1: 19.8529,
    x2: 29.437,
    y2: 2.09803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1771_58808",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8635 22.0494) rotate(-64.1898) scale(86.8194 40.3056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamatoryIcon);
export default __webpack_public_path__ + "static/media/exclamatory-icon.ba9ce4d03bd20541eac35f84c23ac702.svg";
export { ForwardRef as ReactComponent };